import AlgorithmPage from "../../pages/algorithm/AlgorithmPage";
import ConfiguracionGlobalTalentosPage from "../../pages/configuracionTalentos/ConfiguracionGlobalTalentosPage";
import FrasesPage from "../../pages/frases/FrasesPage";
import FrasesRespuestaPage from "../../pages/frasesRespuesta/FrasesRespuestaPage";
import PlantelConfigurationPage from "../../pages/plantels/PlantelConfigurationPage";
import PlantelsPage from "../../pages/plantels/PlantelsPage";
import SchoolPage from "../../pages/schools/SchoolPage";
import TalentosPage from "../../pages/talentos/TalentosPage";
import UsersPage from "../../pages/UsersPage";
import PreguntasConfirmacionPage from "../../pages/preguntasConfirmacion/PreguntasConfirmacionPage";
import FrasesConfirmacionPage from "../../pages/frasesConfirmacion/FrasesConfirmacionPage";
import { ROLES } from "../role.constants";
import PlantelConfirmationPage from "../../pages/plantels/PlantelConfirmationPage";
import PhraseApplicationPage from "../../pages/PhrasesAplication/PhraseApplicationPage";
import ActivitiesApplicationPage from "../../pages/activities-application/ActivitiesApplicationPage";
import PlantelApplicationPage from "../../pages/plantels/PlantelApplicationPage";

export const adminRoutes = [
  {
    path: "/usuarios",
    element: <UsersPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/escuelas",
    element: <SchoolPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/planteles",
    element: <PlantelsPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/talentos",
    element: <TalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases",
    element: <FrasesPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases-respuesta",
    element: <FrasesRespuestaPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/configurar-algoritmo",
    element: <AlgorithmPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/configuracion-global-talentos",
    element: <ConfiguracionGlobalTalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-talentos/:plantelId",
    element: <PlantelConfigurationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/preguntas-confirmacion",
    element: <PreguntasConfirmacionPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases-confirmacion",
    element: <FrasesConfirmacionPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-confirmación-talentos/:plantelId",
    element: <PlantelConfirmationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/actividades-aplicacion",
    element: <ActivitiesApplicationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases-aplicacion",
    element: <PhraseApplicationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-aplicacion-de-talentos/:plantelId",
    element: <PlantelApplicationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
];
